import React from 'react';

export interface MessageBoardPostAudienceProps {
  /**
   * Scope/audience label. Today this is the foreman area name.
   * Swap the caller to "My team" / "Everyone at {site}" / "Foreman area · {name}"
   * once/if the schema supports broader scopes — this component stays a one-line change.
   */
  label: string;
}

const MessageBoardPostAudience: React.FC<MessageBoardPostAudienceProps> = ({ label }) => (
  <span>{label}</span>
);

export default MessageBoardPostAudience;
